export default __webpack_public_path__ + "static/media/mk23-socom.3cdaa6f2.svg";